// extracted by mini-css-extract-plugin
module.exports = {"private":"PrivatePage_private__fBNlM","container":"PrivatePage_container__1Ga7L","menu":"PrivatePage_menu__2HQQc","content":"PrivatePage_content__3hkqc"};